module.exports = __webpack_public_path__ + "static/media/05.5eff5a0c.jpg";